import { axiosInstance } from '../App';
import {
    CashClosingDTO,
    CashClosingDetailDTO,
    CashClosingTransferDTO,
    CreateCashClosingRequestDTO,
    CreateCashClosingTransferRequestDTO,
    ExpectedAmountDTO,
    FinancialAccountResponseDTO,
} from '../dto/CashClosingDTO';

const BASE = '/api/secured/cashclosing';

export function createCashClosing(body: CreateCashClosingRequestDTO): Promise<CashClosingDTO> {
    return axiosInstance.post(`${BASE}/createCashClosing`, body).then(r => r.data);
}

export function getCashClosings(offset = 0, pageSize = 20, locationCashRegisterId?: number): Promise<CashClosingDTO[]> {
    return axiosInstance.get(`${BASE}/getCashClosings`, {
        params: { offset, pageSize, ...(locationCashRegisterId ? { locationCashRegisterId } : {}) },
    }).then(r => r.data);
}

export function getCashClosingDetails(cashClosingId: number): Promise<CashClosingDetailDTO[]> {
    return axiosInstance.get(`${BASE}/getCashClosingDetails`, { params: { cashClosingId } }).then(r => r.data);
}

export function getCashClosingTransfers(cashClosingId: number): Promise<CashClosingTransferDTO[]> {
    return axiosInstance.get(`${BASE}/getCashClosingTransfers`, { params: { cashClosingId } }).then(r => r.data);
}

export function registerCashClosingTransfer(body: CreateCashClosingTransferRequestDTO): Promise<CashClosingTransferDTO> {
    return axiosInstance.post(`${BASE}/registerTransfer`, body).then(r => r.data);
}

export function getExpectedAmount(
    locationCashRegisterId: number,
    fromDatetime: string,
    toDatetime: string,
): Promise<ExpectedAmountDTO> {
    return axiosInstance.get(`${BASE}/getExpectedAmount`, {
        params: { locationCashRegisterId, fromDatetime, toDatetime },
    }).then(r => r.data);
}

export function getFinancialAccounts(): Promise<FinancialAccountResponseDTO[]> {
    return axiosInstance.get(`${BASE}/getFinancialAccounts`).then(r => r.data);
}
